module.exports = __webpack_public_path__ + "img/services.b0237469.svg";